import { Controller } from "react-hook-form";
import Functions from "./index.function";
const MultiSelectDropdown = ({
  options = [],
  control,
  name,
  label,
  iconStyle,
  icon,
  valueoption,
  valueName,
  rightIcon,
  isLoadingpreFiled,
  isLoading,
  isMandatory,
  errors,
  watch,
  isRequired,
}) => {
  const {
    dropdownRef,
    isOpen,
    toggleDropdown,
    searchTerm,
    searchInputRef,
    filteredOptions,
    setSearchTerm,
  } = Functions(options, valueName);
  return (
    <Controller
      name={name}
      control={control}
      rules={isRequired ? {} : { required: `${label} is required` }}
      render={({ field: { onChange, value = [] }, fieldState: { error } }) => {
        const handleSelect = (selectedValue) => {
          const exists = value.includes(selectedValue);
          const updated = exists
            ? value.filter((val) => val !== selectedValue)
            : [...value, selectedValue];
          onChange(updated);
        };

        const selectedOptions = options.filter((opt) =>
          value.includes(opt[valueoption])
        );

        return (
          <div
            className={`relative ${
              isLoading || isLoadingpreFiled
                ? "opacity-50 cursor-not-allowed"
                : ""
            }`}
            ref={dropdownRef}
          >
            <div className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center">
              <label
                htmlFor={name}
                className="xs:text-sm sm:text-base font-onestRegular text-secondary"
              >
                {label}
              </label>
              {isMandatory && (
                <p className="text-errorRed pl-1 text-lg leading-3">*</p>
              )}
            </div>

            <div
              className={`relative xs:pl-6 sm:pl-6 lg:pl-8 bg-[#171717] xs:text-sm sm:text-base font-onestRegular w-full xs:py-3 sm:py-3.5 rounded-full text-[#808080] transition duration-300 border-2 
                                ${
                                  isOpen
                                    ? "border-goldMetallic"
                                    : "border-transparent"
                                }`}
              onClick={toggleDropdown}
            >
              <div className="flex items-center justify-between flex-wrap gap-y-1">
                <div className="max-h-16 overflow-y-auto w-full dashboard-scrollbar">
                  <div className="flex flex-wrap gap-2 text-white max-w-[90%]">
                    {selectedOptions.length > 0 ? (
                      selectedOptions.map((opt) => (
                        <span
                          key={opt[valueoption]}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSelect(opt[valueoption]);
                          }}
                          className="bg-goldMetallic px-2 py-1 rounded-full text-xs cursor-pointer flex items-center gap-1"
                        >
                          {opt[valueName]} <span className="text-sm">×</span>
                        </span>
                      ))
                    ) : (
                      <span className="text-[#808080]">{`Select ${label}`}</span>
                    )}
                  </div>
                </div>

                {icon && (
                  <img
                    className={`absolute left-5 top-1/2 transform -translate-y-1/2 ${iconStyle}`}
                    src={icon}
                    alt={`${name} icon`}
                  />
                )}
                <img
                  className="absolute right-5 inset-y-0 my-auto w-5 h-5 transition-transform duration-500"
                  src={rightIcon}
                  alt="Dropdown icon"
                  style={{
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                />
              </div>
            </div>

            {isOpen && (
              <div className="absolute z-10 w-full bg-[#171717] rounded-3xl mt-2 border-goldMetallic border-2 shadow-lg">
                <div className="px-4 py-2">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    ref={searchInputRef}
                    className="w-full bg-[#121212] border border-[#2a2a2a] rounded-full px-4 py-2 text-sm text-white outline-none"
                  />
                </div>
                <ul className="text-white max-h-60 overflow-y-auto dashboard-scrollbar pr-1">
                  {filteredOptions.length > 0 ? (
                    filteredOptions.map((option) => {
                      const isSelected = value.includes(option[valueoption]);
                      return (
                        <li
                          key={option[valueoption]}
                          onClick={() => handleSelect(option[valueoption])}
                          className={`py-2 px-4 cursor-pointer rounded-full hover:bg-[#222] transition duration-200 flex justify-start gap-2 items-center ${
                            isSelected ? "text-goldMetallic" : ""
                          }`}
                        >
                          {isSelected && <span className="text-sm">✔</span>}
                          {option[valueName]}
                        </li>
                      );
                    })
                  ) : (
                    <li className="py-3 px-4 text-center text-[#808080]">
                      No options found
                    </li>
                  )}
                </ul>
              </div>
            )}

            <div className="flex justify-start items-center xs:pl-6 sm:pl-6 lg:pl-8 xs:pt-[2px] sm:pt-1">
              {errors?.[name] && (
                <span className="text-orangeCrayola font-onestRegular xs:text-xs sm:text-sm">
                  {errors?.[name].message}
                </span>
              )}
            </div>
          </div>
        );
      }}
    />
  );
};

export default MultiSelectDropdown;
